import React,{useContext,createContext} from 'react'
import styled from 'styled-components'
import Nav from './header-nav.js'
import {useState} from 'react'
import {menu} from '../../data/site'

const HeaderContext = createContext({})
export const useHeaderContext = () => useContext(HeaderContext)

const UnstyledHeader = ({
  className
}) => {
  const props = {
    className
  }

  const [mobileMenuIsOpen,setMobileMenuIsOpen] = useState(false)

  const context = {
    menu,
    mobileMenuIsOpen,
    setMobileMenuIsOpen
  }

  return (
    <HeaderContext.Provider value={context}>
      <Header {...props}>
        <Nav/>
      </Header>
    </HeaderContext.Provider>
  )
}

const Header = styled.header`
  width: 100%;
  z-index: 100;
`

export default UnstyledHeader

